import * as React from 'react';
import { SVGProps } from 'react';
import { SvgIcon } from '@mui/material';

export const SvgDot = (props: SVGProps<SVGSVGElement>) => (
    <svg
        fill="none"
        height="24"
        width="24"
        {...props}
        viewBox="0 0 24 24"
        xmlns="http://www.w3.org/2000/svg"
    >
        <circle cx="12" cy="12" fill="current" r="4" />
    </svg>
);

export const DotIcon = ({
    fontSize = 'inherit',
    color = 'inherit',
    ...props
}: React.ComponentProps<typeof SvgIcon>) => (
    <SvgIcon {...props} color={color} component={SvgDot} fontSize={fontSize} />
);
